import React, { useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router";
import { isAuthorized } from "../Utils/IsAuthorized";
import LoadingSpinner from "../Components/LoadingSpinner/LoadingSpinner";

type Props = { children: React.ReactNode };

const ProtectedRoute = ({ children }: Props) => {
  const [isAuthenticated, setIsAuthenticted] = useState("");

  const location = useLocation();
  useEffect(() => {
    const verifyAuthorization = async () => {
      try {
        const res = await isAuthorized();
        res === true
          ? setIsAuthenticted("Authorized")
          : setIsAuthenticted("UnAuthorized");
      } catch {
        setIsAuthenticted("UnAuthorized");
      }
    };
    verifyAuthorization();
  }, []);
  if (isAuthenticated === "") {
    return <LoadingSpinner />;
  }
  return isAuthenticated === "Authorized" ? (
    <>{children}</>
  ) : (
    <Navigate to="/login" state={{ from: location }} replace />
  );
};

export default ProtectedRoute;
